module.exports = __webpack_public_path__ + "static/media/calendar.3d086de4.svg";